import type { DetailFieldProps } from "./types-detail-field";
import { useDetailField } from "./use-detail-field";
import { DetailFieldView } from "./view-detail-field";

export function DetailField(props: DetailFieldProps) {
  const vm = useDetailField(props);

  return <DetailFieldView {...vm} />;
}

export type * from "./types-detail-field";
